module.exports = __webpack_public_path__ + "static/media/Apple iMac Retina.47d88eb5.png";